import { render, staticRenderFns } from "./Table-data.vue?vue&type=template&id=f4dd599a&"
import script from "./Table-data.vue?vue&type=script&lang=js&"
export * from "./Table-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports